<template>
  <div class="pages">

    <v-toolbar color="transparent" flat>
      <v-toolbar-title>Pages ({{ totalPages }})</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-banner>
      All pages present within this project.
    </v-banner>

    <v-data-table
    :headers="headers"
    :items="pages"
    :loading="loading"
    :itemsPerPage="25"
    :server-items-length="totalPages"
    :footer-props="{ itemsPerPageOptions: [25] }"
    :options.sync="options"
    disable-sort
    class="elevation-1"
    >

    <template v-slot:item.urls="{ item }">
      <ExternalLink :link="item.url" />
    </template>

    <template v-slot:item.crawled_at="{ item }">
      {{ item.crawled_at | shortDate }}
    </template>

    </v-data-table>

  </div>
</template>

<script>

import ExternalLink from '@/components/ExternalLink'
import { fetchPages } from '@/api'

export default {
  name: 'pages',
  props: ['projectId'],
  components: { ExternalLink },
  data () {
    return {
      headers: [
        { text: '#', value: 'id' },
        { text: 'URLs', value: 'urls' },
        { text: 'Crawled', value: 'crawled_at' },
        { text: 'Visited', value: 'last_visited_at' },
      ],
      loading: false,
      options: {},
      pages: [],
      totalPages: 0
    }
  },

  watch: {
    options: {
      handler: 'getDataFromApi',
      deep: true,
    }
  },

  methods: {

    getDataFromApi () {
      this.loading = true
      const { page } = this.options
      fetchPages(this.projectId, { page }).then(data => {
        this.pages = data.entries
        this.totalPages = data.total
        this.loading = false
      })
    }

  }

}

</script>
